import type { ShopVisibilitySettings } from '../@models/shop-visibility';

export const DEFAULT_VISIBILITY_SETTINGS: ShopVisibilitySettings = {
  schemaVersion: 1,
  profile: {
    publicProfileEnabled: true,
    showDescription: true,
    showBusinessHours: true,
    showHolidayHours: true,
    showGallery: true,
    showReviews: true,
    showRatingSummary: true,
  },
  discovery: { discoverable: true, showInNearbySearch: true, showInCategorySearch: true },
  location: { showAddress: true, showMapPin: true, showCityRegion: true },
  contact: { showBusinessPhone: true, showBusinessEmail: false },
  services: { showServices: true, showPrices: true, showDurations: true },
  members: { showTeam: true, showProfessionalTitles: true, showMemberRatings: true },
  booking: { showBookButton: true, showAvailabilityPreview: true },
};
